// extracted by mini-css-extract-plugin
module.exports = {"h":"styles_h__7zWGG","v":"styles_v__y0jM_"};